import React, {useEffect, useRef, useState} from 'react'
import {getResource, updateResource} from "../../service/http-service";
import {Combo} from "../../ui/Combo";
import './ProfileFormsStyle.css'
import FormHeader from '../../../assets/img/profile-images/form-header.png'
import {DatePicker, DatePickerComponent} from "../../ui/DatePickerComponent";
import moment from 'moment';

export const ProfilePersonalInformationForm = ({entityTemp,setEntityTemp,title,updateEntity,setUpdateEntity, addEntity, setAddEntity}) => {

    const [entity, setEntity] = useState(entityTemp.entity)

    const [municipalities, setMunicipalities] = useState([])
    const [foreignLanguages, setForeignLanguages] = useState([])

    const [showFirstNameError, setShowFirstNameError] = useState(false)
    const [showLastNameError, setShowLastNameError] = useState(false)
    const [showPhoneError, setShowPhoneError] = useState(false)
    const [showBirthDateError, setShowBirthDateError] = useState(false)
    const [backError, setBackError] = useState('');

    const PersonalInfoRef = useRef(null);

    const goToPersonalInfoForm = () =>
        window.scrollTo({
            top: PersonalInfoRef.current.offsetTop,
            behavior: "auto",
        });


    const constrictCyrillicValues = (e) => {
        const re = /[АБВГДЃЕЖЗЅИЈКЛЉМНЊОПРСТЌУФХЦЧЏШ абвгдѓежзѕијклљмнњопрстќуфхцчџшш:]+/g;
        if (!re.test(e.key)) {
            e.preventDefault();
        }
    };

    const subtractFromDate = (
        date,
        { years, days, hours, minutes, seconds, milliseconds } = {}
    ) => {
        const millisecondsOffset = milliseconds ?? 0
        const secondsOffset = seconds ? 1000 * seconds : 0
        const minutesOffset = minutes ? 1000 * 60 * minutes : 0
        const hoursOffset = hours ? 1000 * 60 * 60 * hours : 0
        const daysOffset = days ? 1000 * 60 * 60 * 24 * days : 0
        const dateOffset =
            millisecondsOffset +
            secondsOffset +
            minutesOffset +
            hoursOffset +
            daysOffset

        let newDate = date
        if (years) newDate = date.setFullYear(date.getFullYear() - years)
        newDate = new Date(newDate - dateOffset)
        return newDate
    }


    useEffect (() => {
        getResource('candidates/get_logged_user_candidate').then(data => {
            setEntity(data.data);
        })
        getResource('municipalities/get_active').then((data) => {
            console.log(`municipalities`)
            console.log(data.data)
            setMunicipalities(data.data)
        })
        getResource('foreign_languages').then((data) => {
            console.log(`foreign_languages`)
            console.log(data.data)
            setForeignLanguages(data.data)
        })
    }, []);

    return (

            <div className="background-form col-12 p-0">
                {(entity && entity.id) && (<>
                        <img src={FormHeader} className="form-header-image"/>
                        <div className="profile_add_button form-button-title personal-info-header-button">{title}</div>
                        <div className="personal-info-form-container">
                                <label>Име</label>
                                <input
                                    type="text"
                                    value={entity.firstName}
                                    onKeyPress={(e) => constrictCyrillicValues(e)}
                                    onChange={(e) => {
                                        setEntity({...entity, firstName: e.target.value})
                                        setShowFirstNameError(false)
                                    }}/>
                                {showFirstNameError && <b>Ве молиме внесете го вашето име</b>}
                                <label className="w-100">Презиме</label>
                                <input
                                    type="text"
                                    value={entity.lastName}
                                    onKeyPress={(e) => constrictCyrillicValues(e)}
                                    onChange={(e) =>{
                                        setEntity({...entity, lastName: e.target.value})
                                        setShowLastNameError(false)
                                    }}/>
                                {showLastNameError && <b>Ве молиме внесете го вашето презиме</b>}
                                <label>Датум на раѓање</label>
                                <DatePickerComponent
                                    maxDate={subtractFromDate(new Date(), { years: 14 })}
                                    minDate={subtractFromDate(new Date(), { years: 64 })}
                                    selectedDate={entity.birthDate}
                                    onChange={(e)=> setEntity({...entity, birthDate:e})}/>
                                {showBirthDateError && <b>Ве молиме внесете датум на раѓање</b>}
                                <label>Телефон за контакт</label>
                                <input
                                    type="number"
                                    value={entity.phone}
                                    onChange={(e) =>{
                                        setEntity({...entity, phone: e.target.value})
                                        setShowPhoneError(false)
                                    }}/>
                                {showPhoneError && <b>Ве молиме внесете телефон за контакт</b>}
                                <label>LinkedIn</label>
                                <input
                                    type="text"
                                    value={entity.linkedIn}
                                    onChange={(e) =>
                                        setEntity({...entity, linkedIn: e.target.value})}/>
                            {(foreignLanguages && foreignLanguages.length > 0) &&
                                (
                                    <>
                                        <Combo
                                            tooltipText="Одберете мајчин јазик"
                                            comboClass="combo-form"
                                            placeholder="Мајчин јазик"
                                            entity={(entity.nativeLanguage) && entity.nativeLanguage.name}
                                            onChange={(e) => {
                                                let chosenForeignLanguages = {};
                                                chosenForeignLanguages.id = e.target.value;
                                                setEntity({ ...entity, nativeLanguage: chosenForeignLanguages })
                                            }}
                                            onClear={() => setEntity({...entity, nativeLanguage:null})}
                                            array={foreignLanguages}/></>)}
                            {(municipalities && municipalities.length > 0) &&
                                (
                                    <>
                                        <Combo
                                            tooltipText="Одберете општина на живеење"
                                            comboClass="combo-form"
                                            placeholder="Општина"
                                            entity={(entity.placeOfLiving) && entity.placeOfLiving.name}
                                            onChange={(e) => {
                                                let chosenMunicipalities = {};
                                                chosenMunicipalities.id = e.target.value;
                                                setEntity({ ...entity, placeOfLiving: chosenMunicipalities })
                                            }}
                                            onClear={() => setEntity({...entity, placeOfLiving:null})}
                                            array={municipalities}/></>)}
                            {backError && <b>{backError}</b>}
                            <div className="col-12 d-flex justify-content-around flex-wrap">
                                <div
                                    className="btn-form personal-form-btn"
                                    onClick={()=> {
                                        setAddEntity(false)
                                        setEntityTemp(entityTemp.entity)
                                    }}
                                >Затвори</div>
                                <div
                                    className="btn-form personal-form-btn"
                                    onClick={(e) => {
                                        if((entity.firstName && entity.firstName.length >  2) &&
                                            (entity.lastName && entity.lastName.length > 2) &&
                                            (entity.birthDate) && (entity.phone && entity.phone.length >= 7)) {
                                            updateResource('candidates', entity)
                                                .then((data) => {
                                                    setEntityTemp(data.data);
                                                    setUpdateEntity(!updateEntity);
                                                    setShowFirstNameError(false);
                                                    setShowLastNameError(false);
                                                    setShowBirthDateError(false);
                                                    setShowPhoneError(false);
                                                    setAddEntity(false);
                                                }).catch((exception) => {
                                                    console.log(exception.response.data.message)
                                                setBackError(exception.response.data.message);
                                            })
                                        }
                                        else if (!entity.firstName || entity.firstName === "" || entity.firstName.length < 2) {
                                            setShowFirstNameError(true)
                                        } else if (!entity.lastName || entity.lastName === "" || entity.lastName.length < 2) {
                                            setShowLastNameError(true)
                                        } else if (!entity.birthDate) {
                                            setShowBirthDateError(true)
                                        } else if (!entity.phone || entity.phone === "" || entity.phone.length < 7) {
                                            setShowPhoneError(true)
                                        }

                                    }}
                                >Зачувај</div>
                            </div>
                        </div>
            </>
            )
                }
        </div>
    )
}